<div class="container-fluid p-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div class="d-flex align-items-center gap-4">
      <div>
        <h1 class="mb-0">Dynamic Fields - {{ countryDetails.displayName }}</h1>
        <p class="text-muted">Manage dynamic fields configuration for {{ countryDetails.displayName }}</p>
      </div>
      @if (countryDetails.logo) {
        <div class="d-flex align-items-center">
          <img [src]="countryDetails.icon" class="img-fluid" style="height: 40px; object-fit: contain;" alt="{{ countryDetails.displayName }} logo">
        </div>
      }
    </div>
    <button class="btn btn-sm btn-light" (click)="goBack()">
      <i class="bi bi-arrow-left me-2"></i>Back to Countries
    </button>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">Fields Configuration</h5>
            <span class="text-muted small">Total Fields: {{ dynamicFields.length }}</span>
          </div>
        </div>
        <div class="card-body">
          <!-- Loading State -->
          @if (loading) {
            <div class="d-flex justify-content-center align-items-center py-5">
              <div class="text-center">
                <div class="spinner-border text-primary mb-3" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p class="text-muted">Loading dynamic fields...</p>
              </div>
            </div>
          }

          @if (!loading) {
            <div>
              <!-- Unsaved Changes Indicator -->
              @if (hasUnsavedChanges()) {
                <div class="alert alert-warning alert-dismissible fade show mb-4" role="alert">
                  <i class="bi bi-exclamation-triangle me-2"></i>You have unsaved changes
                  <button type="button" class="btn-close" (click)="revertChanges()" aria-label="Revert"></button>
                </div>
              }
              <div class="mb-4">
                <p class="text-muted small">
                  <i class="bi bi-info-circle me-1"></i>All operations are local. Click "Save Changes" to apply.
                </p>
              </div>
              <div class="drag-drop-container" cdkDropList (cdkDropListDropped)="onDragDrop($event)">
                <!-- Add New Field Form (In-place) -->
                @if (isAdding) {
                  <div class="drag-drop-item card mb-3 border-primary">
                    <div class="card-body">
                      <h6 class="card-title mb-3">Add New Dynamic Field</h6>
                      <form #addFieldForm="ngForm" (ngSubmit)="saveDynamicField()">
                        <div class="row g-3">
                          <div class="col-md-6">
                            <label class="form-label">Label <span class="text-danger">*</span></label>
                            <input
                              type="text"
                              class="form-control"
                              [(ngModel)]="newField.label"
                              name="label"
                              required
                              placeholder="Field label"
                              >
                          </div>
                          <div class="col-md-6">
                            <label class="form-label">Data Type <span class="text-danger">*</span></label>
                            <select
                              class="form-select"
                              [(ngModel)]="newField.datatype"
                              name="datatype"
                              required
                              (change)="onDataTypeChange(newField, $event.target['value'])"
                              >
                              <option value="text">Text</option>
                              <option value="number">Number</option>
                              <option value="select">Select</option>
                              <option value="date">Date</option>
                              <option value="image">Image</option>
                            </select>
                          </div>
                          <!-- Validation Pattern and Message (hidden for select and date) -->
                          @if (newField.datatype !== 'select' && newField.datatype !== 'date') {
                            <div class="col-md-6">
                              <label class="form-label">Validation Pattern</label>
                              <input
                                type="text"
                                class="form-control"
                                [(ngModel)]="newField.validationPattern"
                                name="validationPattern"
                                placeholder="e.g., ^[a-zA-Z0-9]+$"
                                >
                              <div class="form-text">Regular expression to validate input</div>
                            </div>
                          }
                          @if (newField.datatype !== 'select' && newField.datatype !== 'date') {
                            <div class="col-md-6">
                              <label class="form-label">Validation Message</label>
                              <input
                                type="text"
                                class="form-control"
                                [(ngModel)]="newField.validationMessage"
                                name="validationMessage"
                                placeholder="e.g., Only alphanumeric characters allowed"
                                >
                              <div class="form-text">Message to display if validation fails</div>
                            </div>
                          }
                          <!-- Date Format Hint (only for date type) -->
                          @if (newField.datatype === 'date') {
                            <div class="col-md-12">
                              <div class="alert alert-info mb-0">
                                <i class="bi bi-info-circle me-2"></i>
                                Date format must be <strong>DD-MM-YYYY</strong>
                              </div>
                            </div>
                          }
                          <!-- Select Options (only for select type) -->
                          @if (newField.datatype === 'select') {
                            <div class="col-md-12">
                              <label class="form-label">Select Options <span class="text-danger">*</span></label>
                              <div class="mb-2">
                                <button type="button" class="btn btn-sm btn-outline-primary" (click)="addSelectOption(newField)">
                                  <i class="bi bi-plus-circle me-1"></i>Add Option
                                </button>
                              </div>
                              @for (option of newField.options; track option; let i = $index) {
                                <div class="row g-2 mb-2 align-items-end">
                                  <div class="col-md-4">
                                    <input
                                      type="text"
                                      class="form-control"
                                      [(ngModel)]="newField.options[i].label"
                                      name="optionLabel_{{i}}"
                                      placeholder="Option label"
                                      >
                                  </div>
                                  <div class="col-md-4">
                                    <input
                                      type="text"
                                      class="form-control"
                                      [(ngModel)]="newField.options[i].value"
                                      name="optionValue_{{i}}"
                                      placeholder="Option value"
                                      >
                                  </div>
                                  <div class="col-md-3">
                                    <input
                                      type="text"
                                      class="form-control"
                                      [(ngModel)]="newField.options[i].imageUrl"
                                      name="optionImage_{{i}}"
                                      placeholder="Image URL"
                                      >
                                  </div>
                                  <div class="col-md-1">
                                    <button
                                      type="button"
                                      class="btn btn-sm btn-outline-danger"
                                      (click)="removeSelectOption(newField, i)"
                                      [disabled]="newField.options.length <= 1"
                                      >
                                      <i class="bi bi-trash"></i>
                                    </button>
                                  </div>
                                </div>
                              }
                            </div>
                          }
                          <div class="col-md-12">
                            <div class="form-check form-switch">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                [(ngModel)]="newField.isRequired"
                                name="isRequired"
                                id="isRequired"
                                >
                              <label class="form-check-label" for="isRequired">
                                <i class="bi bi-asterisk text-danger me-1"></i>Required Field
                              </label>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-check form-switch">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                [(ngModel)]="newField.isMasked"
                                name="isMasked"
                                id="isMasked"
                                >
                              <label class="form-check-label" for="isMasked">
                                <i class="bi bi-eye-slash me-1"></i>Masked Input
                              </label>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <label class="form-label">Match With Field</label>
                            <select
                              class="form-select"
                              [(ngModel)]="newField.matchWith"
                              name="matchWith"
                              >
                              <option value="">None (no validation)</option>
                              @for (field of getNonCurrentFields(newField); track field) {
                                <option [value]="field.label">
                                  {{ field.label }}
                                </option>
                              }
                            </select>
                            <div class="form-text">Select a field to match values with (for confirm fields)</div>
                          </div>
                          <div class="col-md-12">
                            <div class="d-flex gap-2">
                              <button type="submit" class="btn btn-primary" [disabled]="!addFieldForm.form.valid">
                                <i class="bi bi-check-circle me-2"></i>Save
                              </button>
                              <button type="button" class="btn btn-light" (click)="cancelAdd()">
                                <i class="bi bi-x-circle me-2"></i>Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                }
                <!-- Existing Fields -->
                @for (field of dynamicFields; track field) {
                  <div
                    class="drag-drop-item card mb-3"
                    cdkDrag
                    >
                    <div class="card-body">
                      <!-- Field View Mode -->
                      @if (!field.isEditing) {
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="d-flex align-items-center gap-3">
                            <div class="drag-handle">
                              <i class="bi bi-grip-vertical text-muted"></i>
                            </div>
                            <div>
                              <h6 class="mb-0">{{ field.label }}</h6>
                              <div class="d-flex gap-2 mt-1">
                                <span class="badge bg-primary">{{ field.datatype }}</span>
                                @if (field.isRequired) {
                                  <span class="badge bg-danger">
                                    <i class="bi bi-asterisk me-1"></i>Required
                                  </span>
                                }
                                @if (field.isMasked) {
                                  <span class="badge bg-secondary">
                                    <i class="bi bi-eye-slash me-1"></i>Masked
                                  </span>
                                }
                                @if (field.validationPattern) {
                                  <span class="badge bg-info">
                                    <i class="bi bi-shield-check me-1"></i>Validated
                                  </span>
                                }
                              </div>
                              @if (field.matchWith) {
                                <div class="mt-1">
                                  <small class="text-muted">
                                    <i class="bi bi-link-45deg me-1"></i>
                                    Matches with: {{ field.matchWith }}
                                  </small>
                                </div>
                              }
                              @if (field.validationMessage && field.datatype !== 'select') {
                                <div class="mt-2">
                                  <small class="text-muted">
                                    <i class="bi bi-exclamation-circle me-1"></i>
                                    {{ field.validationMessage }}
                                  </small>
                                </div>
                              }
                              @if (field.datatype === 'select' && field.options.length > 0) {
                                <div class="mt-2">
                                  <small class="text-muted">
                                    <i class="bi bi-list me-1"></i>
                                    Options: {{ getSelectOptionsLabels(field.options) }}
                                  </small>
                                </div>
                              }
                            </div>
                          </div>
                          <div class="d-flex gap-2">
                            <span class="text-muted small">Priority: {{ field.priority }}</span>
                            <button class="btn btn-sm btn-outline-primary" (click)="startEditing(field)">
                              <i class="bi bi-pencil-fill me-1"></i>Edit
                            </button>
                            <button class="btn btn-sm btn-outline-danger" (click)="onDelete({ data: field })">
                              <i class="bi bi-trash-fill me-1"></i>Delete
                            </button>
                          </div>
                        </div>
                      }
                      <!-- Field Edit Mode -->
                      @if (field.isEditing) {
                        <div class="edit-mode">
                          <h6 class="card-title mb-3">Edit Field</h6>
                          <form #editFieldForm="ngForm" (ngSubmit)="saveEdit(field)">
                            <div class="row g-3">
                              <div class="col-md-6">
                                <label class="form-label">Label <span class="text-danger">*</span></label>
                                <input
                                  type="text"
                                  class="form-control"
                                  [(ngModel)]="field.label"
                                  name="label"
                                  required
                                  >
                              </div>
                              <div class="col-md-6">
                                <label class="form-label">Data Type <span class="text-danger">*</span></label>
                                <select
                                  class="form-select"
                                  [(ngModel)]="field.datatype"
                                  name="datatype"
                                  required
                                  (change)="onDataTypeChange(field, $event.target['value'])"
                                  >
                                  <option value="text">Text</option>
                                  <option value="number">Number</option>
                                  <option value="select">Select</option>
                                  <option value="date">Date</option>
                                  <option value="image">Image</option>
                                </select>
                              </div>
                              <!-- Validation Pattern and Message (hidden for select and date) -->
                              @if (field.datatype !== 'select' && field.datatype !== 'date') {
                                <div class="col-md-6">
                                  <label class="form-label">Validation Pattern</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    [(ngModel)]="field.validationPattern"
                                    name="validationPattern"
                                    placeholder="e.g., ^[a-zA-Z0-9]+$"
                                    >
                                  <div class="form-text">Regular expression to validate input</div>
                                </div>
                              }
                              @if (field.datatype !== 'select' && field.datatype !== 'date') {
                                <div class="col-md-6">
                                  <label class="form-label">Validation Message</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    [(ngModel)]="field.validationMessage"
                                    name="validationMessage"
                                    placeholder="e.g., Only alphanumeric characters allowed"
                                    >
                                  <div class="form-text">Message to display if validation fails</div>
                                </div>
                              }
                              <!-- Date Format Hint (only for date type) -->
                              @if (field.datatype === 'date') {
                                <div class="col-md-12">
                                  <div class="alert alert-info mb-0">
                                    <i class="bi bi-info-circle me-2"></i>
                                    Date format must be <strong>DD-MM-YYYY</strong>
                                  </div>
                                </div>
                              }
                              <!-- Select Options (only for select type) -->
                              @if (field.datatype === 'select') {
                                <div class="col-md-12">
                                  <label class="form-label">Select Options <span class="text-danger">*</span></label>
                                  <div class="mb-2">
                                    <button type="button" class="btn btn-sm btn-outline-primary" (click)="addSelectOption(field)">
                                      <i class="bi bi-plus-circle me-1"></i>Add Option
                                    </button>
                                  </div>
                                  @for (option of field.options; track option; let i = $index) {
                                    <div class="row g-2 mb-2 align-items-end">
                                      <div class="col-md-4">
                                        <input
                                          type="text"
                                          class="form-control"
                                          [(ngModel)]="field.options[i].label"
                                          name="optionLabel_{{i}}"
                                          placeholder="Option label"
                                          >
                                      </div>
                                      <div class="col-md-4">
                                        <input
                                          type="text"
                                          class="form-control"
                                          [(ngModel)]="field.options[i].value"
                                          name="optionValue_{{i}}"
                                          placeholder="Option value"
                                          >
                                      </div>
                                      <div class="col-md-3">
                                        <input
                                          type="text"
                                          class="form-control"
                                          [(ngModel)]="field.options[i].imageUrl"
                                          name="optionImage_{{i}}"
                                          placeholder="Image URL"
                                          >
                                      </div>
                                      <div class="col-md-1">
                                        <button
                                          type="button"
                                          class="btn btn-sm btn-outline-danger"
                                          (click)="removeSelectOption(field, i)"
                                          [disabled]="field.options.length <= 1"
                                          >
                                          <i class="bi bi-trash"></i>
                                        </button>
                                      </div>
                                    </div>
                                  }
                                </div>
                              }
                              <div class="col-md-12">
                                <div class="form-check form-switch">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    [(ngModel)]="field.isRequired"
                                    name="isRequired"
                                    id="isRequired_{{field._id}}"
                                    >
                                  <label class="form-check-label" for="isRequired_{{field._id}}">
                                    <i class="bi bi-asterisk text-danger me-1"></i>Required Field
                                  </label>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-check form-switch">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    [(ngModel)]="field.isMasked"
                                    name="isMasked_{{field._id}}"
                                    id="isMasked_{{field._id}}"
                                    >
                                  <label class="form-check-label" for="isMasked_{{field._id}}">
                                    <i class="bi bi-eye-slash me-1"></i>Masked Input
                                  </label>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <label class="form-label">Match With Field</label>
                                <select
                                  class="form-select"
                                  [(ngModel)]="field.matchWith"
                                  name="matchWith_{{field._id}}"
                                  >
                                  <option value="">None (no validation)</option>
                                  @for (otherField of getNonCurrentFields(field); track otherField) {
                                    <option [value]="otherField.label">
                                      {{ otherField.label }}
                                    </option>
                                  }
                                </select>
                                <div class="form-text">Select a field to match values with (for confirm fields)</div>
                              </div>
                              <div class="col-md-12">
                                <div class="d-flex gap-2">
                                  <button type="submit" class="btn btn-primary" [disabled]="!editFieldForm.form.valid">
                                    <i class="bi bi-check-circle me-2"></i>Save
                                  </button>
                                  <button type="button" class="btn btn-light" (click)="cancelEditing(field)">
                                    <i class="bi bi-x-circle me-2"></i>Cancel
                                  </button>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
              @if (dynamicFields.length === 0 && !isAdding) {
                <div class="text-center py-5">
                  <i class="bi bi-inbox display-4 text-muted mb-3"></i>
                  <h5 class="text-muted">No dynamic fields configured</h5>
                  <p class="text-muted mb-4">Click "Add Dynamic Field" to create your first field</p>
                  <button class="btn btn-primary" (click)="startAdding()">
                    <i class="bi bi-plus-circle me-2"></i>Add Dynamic Field
                  </button>
                </div>
              }
            </div>
          }
        </div>
        <!-- Save Changes Footer -->
        <div class="card-footer bg-light">
          <div class="d-flex justify-content-between align-items-center gap-2">
            <button class="btn btn-primary" (click)="startAdding()">
              <i class="bi bi-plus-lg me-2"></i>Add New Field
            </button>
            <div class="d-flex gap-2">
              <button
                class="btn btn-light"
                (click)="revertChanges()"
                [disabled]="!hasUnsavedChanges()"
                >
                <i class="bi bi-arrow-counterclockwise me-2"></i>Revert Changes
              </button>
              <button
                class="btn btn-primary"
                (click)="saveAllChanges()"
                [disabled]="!hasUnsavedChanges() || loading"
                >
                @if (loading) {
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                }
                <i class="bi bi-save me-2"></i>Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
